import React from "react";
import searchIcon from "../../../assets/images/search.svg";
import MatkaMarketCard from "./MatkaMarketCard";

export default function MatkaMarketsView({
  tabs,
  activeTab,
  onTabChange,
  subTabs = [],
  activeSubTab = "",
  onSubTabChange,
  searchTerm,
  onSearchChange,
  markets,
  isLoading = false,
  errorMessage = "",
  onSelectMarket,
  hideSearch = false,
  content = null,
}) {
  return (
    <>
      {/* Matka Controls Header (Tabs & Search Bar) */}
      <div className="container-fluid custom-padding matka-controls-section">
        <div className="matka-controls-inner d-flex flex-column flex-md-row justify-content-between align-items-center">
          {/* Tabs */}
          <div className="matka-tabs-nav d-flex align-items-center mb-3 mb-md-0">
            {tabs.map((tab) => (
              <button
                key={tab}
                type="button"
                className={`matka-tab-btn ${activeTab === tab ? "active" : ""}`}
                onClick={() => onTabChange(tab)}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Search Bar */}
          {hideSearch ? null : (
            <div className="matka-search-container">
              <input
                type="text"
                className="matka-search-input"
                placeholder="Search for your favourite games..."
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
              />
              <img
                loading="lazy"
                src={searchIcon}
                alt="search"
                className="matka-search-icon"
              />
            </div>
          )}
        </div>

        {subTabs.length ? (
          <div className="matka-subtabs-bar">
            <div className="matka-tabs-nav d-flex align-items-center">
              {subTabs.map((tab) => (
                <button
                  key={tab}
                  type="button"
                  className={`matka-tab-btn ${activeSubTab === tab ? "active" : ""}`}
                  onClick={() => onSubTabChange(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
        ) : null}
      </div>

      {/* Matka Markets Grid */}
      <div className="container-fluid custom-padding matka-grid-section">
        {content ? (
          content
        ) : isLoading ? (
          <div className="matka-empty-state text-center py-5">
            <p className="text-light fs-5">Loading markets...</p>
          </div>
        ) : errorMessage && !markets.length ? (
          <div className="matka-empty-state text-center py-5">
            <p className="text-light fs-5">{errorMessage}</p>
          </div>
        ) : markets.length ? (
          <div className="row g-3 g-md-4">
            {markets.map((market) => (
              <MatkaMarketCard
                key={market.id}
                market={market}
                onClick={() => onSelectMarket(market)}
              />
            ))}
          </div>
        ) : (
          <div className="matka-empty-state text-center py-5">
            <i className="bi bi-search fs-1 text-muted mb-3 d-block"></i>
            <p className="text-light fs-5">
              {searchTerm
                ? `No matka markets found matching "${searchTerm}"`
                : "No markets available."}
            </p>
          </div>
        )}
      </div>
    </>
  );
}
